
export const PROPOSED_STATUS = 'proposed';
export const READY_TO_SEND_STATUS = 'ready-to-send';
export const NOT_READY_TO_SEND_STATUS = 'not-ready-to-send';
